import { render, staticRenderFns } from "./EditExpertPurchaseItem.vue?vue&type=template&id=54d2c644&scoped=true"
import script from "./EditExpertPurchaseItem.vue?vue&type=script&lang=js"
export * from "./EditExpertPurchaseItem.vue?vue&type=script&lang=js"
import style0 from "./EditExpertPurchaseItem.vue?vue&type=style&index=0&id=54d2c644&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d2c644",
  null
  
)

export default component.exports